module.exports = __webpack_public_path__ + "img/chambreetage.ca19281c.jpg";